import { useTranslation } from "react-i18next";
import Text from "../../../../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
const bookMarkHelpItemName = "bookmarkHelp";
export const ShareUrlBookmark = _ref => {
  var _viewState$terria$con;
  let {
    viewState
  } = _ref;
  const {
    t
  } = useTranslation();
  return (_viewState$terria$con = viewState.terria.configParameters.helpContent) !== null && _viewState$terria$con !== void 0 && _viewState$terria$con.some(e => e.itemName === bookMarkHelpItemName) ? /*#__PURE__*/_jsx(Text, {
    medium: true,
    textLight: true,
    isLink: true,
    onClick: evt => viewState.openHelpPanelItemFromSharePanel(evt, bookMarkHelpItemName),
    children: t("share.getShareSaveHelpMessage")
  }) : null;
};